import React from "react"
import { Box, Typography, Container, Card, CardContent } from "@mui/material"
import { useNavigate } from "react-router-dom"
import SportsEsportsIcon from "@mui/icons-material/SportsEsports"
import GroupsIcon from "@mui/icons-material/Groups"
import SiteWrapper from "../../home-pages/SiteWrapper"

const BuzzerLanding = () => {
  const navigate = useNavigate()

  return (
    <SiteWrapper>
      <Container maxWidth="md" sx={{ mt: 8, textAlign: "center", position: "relative", zIndex: 2 }}>
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 900, mb: 6, fontFamily: "'Playfair Display', serif", color: "#fff" }}>
          Live Buzzer
        </Typography>
        
        <Box sx={{ 
          display: "flex", 
          gap: 4, 
          justifyContent: "center",
          flexWrap: "wrap",
          mt: 4
        }}>
          {/* Host Card */}
          <Card 
            sx={{ 
              minWidth: 280, 
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              bgcolor: "rgba(255, 255, 255, 0.03)",
              color: "#fff",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              backdropFilter: "blur(12px)",
              borderRadius: "24px",
              "&:hover": { 
                transform: "scale(1.05) translateY(-8px)",
                borderColor: "#6366f1",
                boxShadow: "0 12px 40px rgba(99, 102, 241, 0.2)"
              }
            }}
            onClick={() => navigate("/buzzer/host")}
          >
            <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 5 }}>
              <GroupsIcon sx={{ fontSize: 80, color: "#6366f1", mb: 2 }} />
              <Typography variant="h4" component="div" gutterBottom sx={{ fontWeight: 800 }}>
                Host
              </Typography>
              <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.5)", lineHeight: 1.6 }}>
                Create a room and display the buzzer status on your screen.
              </Typography>
            </CardContent>
          </Card>

          {/* Join Card */}
          <Card 
            sx={{ 
              minWidth: 280, 
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              bgcolor: "rgba(255, 255, 255, 0.03)",
              color: "#fff",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              backdropFilter: "blur(12px)",
              borderRadius: "24px",
              "&:hover": { 
                transform: "scale(1.05) translateY(-8px)",
                borderColor: "#d946ef",
                boxShadow: "0 12px 40px rgba(217, 70, 239, 0.2)"
              }
            }}
            onClick={() => navigate("/buzzer/client")}
          >
            <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 5 }}>
              <SportsEsportsIcon sx={{ fontSize: 80, color: "#d946ef", mb: 2 }} />
              <Typography variant="h4" component="div" gutterBottom sx={{ fontWeight: 800 }}>
                Join
              </Typography>
              <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.5)", lineHeight: 1.6 }}>
                Join a room with a code and get your buzzer ready!
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </SiteWrapper>
  )
}

export default BuzzerLanding
